<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>

<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-12">
      <p-panel header="{{ 'POLITICAS.LBL_INFOPOLITICA' | translate}}">
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_CODIGO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8 "><strong>{{politica.codigo}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_NOMBRE' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.nombre}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_DESCPERFIL' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8 "><strong>{{politica.descripcion}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_DESCARTA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorDescarta ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_ALERTA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorAlerta ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid" *ngIf="politica.indicadorDescarta">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_POROFICINA' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorOficina ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_PORSEGMENTO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorSegmento ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid" *ngIf="politica.indicadorAlerta">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_REQAPROBACION' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorRequiereAprobacion ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_NIVEL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.nombreNivel}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_RESPUESTA' | translate }}:</label>
          <label class="lg:col-9 col-6 md:col-8 "><strong>{{politica.respuesta}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_TITULAR' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorTitular ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_DEUDORSOL' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorDeudorSolidario ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
        <div class="grid">
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'POLITICAS.LBL_CODEUDOR' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorCodeudor ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
          <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'LBL_HABILITADO' | translate }}:</label>
          <label class="lg:col-3 col-6 md:col-8"><strong>{{politica.indicadorHabilitado ? ('LBL_SI' | translate) : ('LBL_NO' |
            translate)}}</strong></label>
        </div>
      </p-panel>
    </div>
  </div>
  <div class="grid" *ngIf="politica.indicadorDescarta && politica.indicadorOficina">
    <div class="col-12">
      <p-panel header="{{ 'POLITICAS.LBL_OFICINAS' | translate}}">
        <p-table [columns]="colOficinas"
                 [value]="lisPoliticaOficinas" selectionMode="single" dataKey="idPoliticaCreditoOficina"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreOficina}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid" *ngIf="politica.indicadorDescarta && politica.indicadorSegmento">
    <div class="col-12">
      <p-panel header="{{ 'POLITICAS.LBL_SEGMENTOS' | translate}}">
        <p-table [columns]="colSegmentos"
                 [value]="lisPoliticaSegmentos" selectionMode="single" dataKey="idPoliticaCreditoSegmento"
                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                {{col.header}}
                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row">
              <td>{{row.nombreSegmento}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" let-columns>
            <tr>
              <td [attr.colspan]="columns.length">
                {{ 'MSG_NOHAYREGISTROS' | translate}}
              </td>
            </tr>
          </ng-template>
        </p-table>
      </p-panel>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
              pButton (click)="regresar()"></button>
    </div>
  </div>
</div>

